(function() {

  class Header {
    constructor(element) {
      if(!element) return;

      this.element = element;
      this.toggleButton = element.querySelector('.u-header__popup-menu-toggle');
      this.searchButtonDefault = element.querySelector('.u-header__search-toggle--default');
      this.searchButtonMobile = element.querySelector('.u-header__search-toggle--popup-menu');
      this.isOpen = false;
      this.init();

      var event = new CustomEvent('generate-smooth-scroll-links', { detail: element });
      document.dispatchEvent(event);

      document.addEventListener('close-header', () => {
        if(this.isOpen) {
          this.toggleMenu();
        }
      })
    }

    init() {
      this.toggleButton.addEventListener('click', () => {
        this.toggleMenu();
      })
      this.searchButtonDefault.addEventListener('click', () => {
        this.toggleSearch();
      })
      this.searchButtonMobile.addEventListener('click', () => {
        this.toggleSearch(true);
      })

      const goToContentButton = document.querySelector('.u-header__go-to-content-button');

      if (goToContentButton) {
        goToContentButton.addEventListener('click', () => {
          gsap.to(window, {duration: 1, scrollTo:".u-page__main"});
        });
      }

      let lastScrollTop = 0;

      if((window.pageYOffset || document.documentElement.scrollTop) > 0) {
        document.body.classList.add('u-scroll-down');
      }

      var scrollTimer = null;

      window.addEventListener('scroll', () => {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        
        document.body.classList.add('u-scrolling');
        if(scrollTimer) {
          clearTimeout(scrollTimer);
        }
        scrollTimer = setTimeout(() => {
          document.body.classList.remove('u-scrolling');
        }, 1000);

        if(st <= 110) {
          document.body.classList.remove('u-scroll-down');
          document.body.classList.remove('u-scroll-up');
          document.body.classList.add('u-force-header');
        } else if (st > lastScrollTop){
            // downscroll
            document.body.classList.add('u-scroll-down');
            document.body.classList.remove('u-scroll-up');
            document.body.classList.remove('u-force-header');
        } else {
            // upscroll code
            document.body.classList.remove('u-scroll-down');
            document.body.classList.add('u-scroll-up');
            document.body.classList.remove('u-force-header');
        }
        if(st === 0) {
          document.body.classList.remove('u-scroll-up');
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      }, false);

      // mobile
      const submenuTogglers = document.querySelectorAll('.u-main-menu__submenu-toggler');
      const menuItems = document.querySelectorAll('.u-main-menu__item');
      submenuTogglers.forEach((submenuToggler) => {
        submenuToggler.addEventListener('click', () => {
          const isOpen = submenuToggler.closest('.u-main-menu__item').classList.contains('is-open');
    
          menuItems.forEach((menuItem) => {
            menuItem.classList.remove('is-open');
          });
          
          if(!isOpen) {
            submenuToggler.closest('.u-main-menu__item').classList.add('is-open');
          }
        })
      })
    }
    toggleMenu(close) {
      const menu = document.querySelector('.u-header__popup-menu');
      const wrapper = document.querySelector('.u-header__popup-menu-wrapper');
      if(this.isOpen) {
        document.body.style.overflow = 'auto';
        this.element.classList.remove('u-header--is-open');

        let tl = gsap.timeline({
          onComplete: () => {
            wrapper.style.display = 'none';
          }
        });
    
        // add animations and labels to the timeline
        tl.addLabel("start")
          .fromTo(menu, {translateX: '0%'}, {translateX: '100%', duration: .4, ease: Linear.easeOut })
          .addLabel("end");
      } else {
        wrapper.style.display = 'block';
        this.element.classList.add('u-header--is-open');

        let tl = gsap.timeline({
          onComplete() {
            document.body.style.overflow = 'hidden';
          }
        });
    
        // add animations and labels to the timeline
        tl.addLabel("start")
          .fromTo(menu, {translateX: '100%'}, {translateX: '0%', duration: .4, ease: Linear.easeOut})
          .addLabel("end");
      }
      this.isOpen = !this.isOpen;
    }
    toggleSearch(instant) {

      
      const header = document.querySelector('.u-header');
      let hintStr = '';
      let currentLanguage = '';
      if (header) {
        hintStr = header.getAttribute('data-search-hint');
      }
      if (header) {
        currentLanguage = header.getAttribute('data-current-language');
      }

      var event = new CustomEvent('overlay-set-content', {
        detail: {
          html: `<div class="u-search__wrapper">
            <form class="u-search__form">
              <input type="text" name="term" class="u-search__input" autocomplete="off" />
              <button type="submit" class="u-search__submit">Submit</button>
              <span class="u-search__text">${hintStr}</span>
            </form>
            <div class="u-search__result-content" style="display: none"></div>
          </div>`,
          callback: () => {
            document.querySelector('.u-search__form').addEventListener('submit', (e) => {
              e.preventDefault();
              fetch(`${currentLanguage !== 'de' ? `/${currentLanguage}` : ''}/?s=${document.querySelector('.u-search__input').value}`)
              .then(function(response) {
                return response.text()
              }).then(function(body) {

                const searchForm = document.querySelector('.u-search__form');
                const searchFormInput = document.querySelector('.u-search__input');
                const resultContent = document.querySelector('.u-search__result-content');
                searchForm.style.display = 'none';
                resultContent.style.display = 'block';
                resultContent.innerHTML = body;
                const resetButton = resultContent.querySelector('.u-search__reset');
                if (resetButton) {
                  resetButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    searchForm.style.display = 'flex';
                    resultContent.style.display = 'none';
                    resultContent.innerHTML = '';
                    searchFormInput.value = "";
                    setTimeout(function() {
                      searchFormInput.focus();
                    }, 200)
                  })
                }

                document.dispatchEvent(event);
              })
            });

            this.toggleMenu();

            var event = new CustomEvent(instant ? 'overlay-instant-open' : 'overlay-open');
            document.dispatchEvent(event);
            setTimeout(function() {
              document.querySelector('.u-search__input').focus();
            }, 200)
          }
        }
      });
      document.dispatchEvent(event);
    }
  }

  new Header(document.querySelector('.u-header'))

})();